
// Candle object for Candles overlay
import Tooltip from '../../../components/primitives/tooltip.js'

export default class CyclicCandle {

    constructor(overlay, ctx, layout, data, cmp) {
        this.ctx = ctx
        this.layout = layout
        this.self = overlay
        this.style = this.self
        this.cmp = cmp
        this.pTx = 0
        this.pTopTarget = 0
        this.pBx = 0
        this.pBottomTarget = 0

        let _data = (data);
        this._draw(_data, this.self, cmp)
    }

    convert_candle(data) {
        return {
           date: data.raw[0],
           o: data.raw[1],
           h: data.raw[2],
           l: data.raw[3],
           c: data.raw[4],
           v: data.raw[5],
           w: data.w,
           x: data.x
        };

        return data
    }

    _draw(data, self, cmp) {
        // Line width = 1 or 2?
        const line_width = this.style.lineWidth ?  this.style.lineWidth : 2
        var up_hollow = this.style.upCandleHollow
        var down_hollow = this.style.downCandleHollow
        var imbalance = false
        var blackCandle = false

        //console.log("line_width", line_width)
        //console.log("up_hollow", up_hollow)

        var l = self.data.length

        var _data = this.convert_candle(data)

        var body_border_color
        // bar color
        var body_color
        body_color =  this.style.downBodyColor
        body_border_color = this.style.downBarColor

        let width = Math.max(data.w, 1)
        let halfwidth = Math.max(Math.floor(width * 0.5), 1)
        let height = Math.abs(data.o - data.c)
        let max_h = data.c === data.o ? 1 : 2

        let line_width_half = line_width / 2

        // Draw the body
        // Draw a body as a rectangle if it is thick (>1.5).

        let hollow = false
        if (up_hollow && data.c <= data.o)
            hollow = true

        if (hollow) {
            this.ctx.strokeStyle = body_color
            this.ctx.lineWidth = line_width
            let s = data.c >= data.o ? 1 : -1
            this.ctx.beginPath()
            this.ctx.rect(
                Math.floor(data.x - halfwidth - line_width),
                Math.floor(data.o),
                Math.floor(halfwidth * 2 + line_width),
                Math.floor(s * Math.max(height, max_h))
            )
            this.ctx.stroke()
        } else {
            this.ctx.fillStyle = body_color
            this.ctx.strokeStyle = body_border_color
            let s = data.c >= data.o ? 1 : -1
            this.ctx.fillRect(
                Math.floor(data.x - halfwidth - line_width),
                Math.floor(data.o),
                Math.floor(halfwidth * 2 + line_width),
                Math.floor(s * Math.max(height, max_h))
            )
            this.ctx.lineWidth = 0.5
            this.ctx.beginPath()
            this.ctx.rect(
                Math.floor(data.x - halfwidth - line_width),
                Math.floor(data.o),
                Math.floor(halfwidth * 2 + line_width),
                Math.floor(s * Math.max(height, max_h))
            )
            this.ctx.stroke()

            let w = this.ctx.measureText(data.o).width + 10

            this.ctx.fillStyle = body_border_color
            this.ctx.textAlign = 'left'
            this.ctx.fillText(_data.h, _data.x, this.layout.$2screen(_data.h))
            this.ctx.fillText(_data.l, _data.x, this.layout.$2screen(_data.l))
        }
    }
}
